<template>
  <div class="wrapper text-left d-block d-md-flex align-items-center">
    <h3 class="header col-md d-flex align-items-center">{{ title }}</h3>
    <div class="d-flex col-md my-3">
      <p class="col d-md-none p-0 m-0">Előző lezárt pénzügyi év adatai (2022)</p>
      <p class="col p-0 m-0">{{ numberWithDots(Number(amount)) }} {{ measurement }}</p>
    </div>

    <div class="d-flex col-md">
      <p class="col d-md-none px-0">Frissített gazdasági adatok</p>
      <div class="col d-lg-flex align-items-center px-0">
        <b-form-input
          class="col-12 col-xl-6 col-lg-6"
          v-model="modifier"
          @keypress="isNumber($event, keyInStore === 'head_count' ? false : true)"
          min="1"
          max="10000"
          @blur="handleBlur"
        ></b-form-input>
        <p
          :class="
            `col-12 col-xl-6 col-lg-6 multiplied ${
              Number(multiplied - 100) > 0 ? 'increase' : Number(multiplied - 100) < 0 ? 'decrease' : ''
            }`
          "
        >
          <font-awesome-icon
            v-show="Number(multiplied - 100) != 0 && !isNaN(this.result)"
            :icon="`${Number(multiplied - 100) > 0 ? 'fa-solid fa-arrow-up' : 'fa-solid fa-arrow-down'}`"
          />
          {{ this.result == 'Infinity' || isNaN(this.result) ? '' : this.result + ' %' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  props: {
    title: { type: String, required: true },
    amount: { type: Number, required: true, default: 0 },
    measurement: { type: String, required: true },
    keyInStore: { type: String, required: true },
    alreadySelected: {}
  },
  data() {
    return {
      modifier: ''
    }
  },
  computed: {
    multiplied() {
      return this.modifier ? Math.floor((Number(this.modifier) / Number(this.amount)) * 100) : 100
    },
    result() {
      return Number(this.multiplied - 100) < 0
        ? String(this.multiplied - 100).substring(1)
        : Number(this.multiplied - 100)
    }
  },
  methods: {
    addCompanyAttribute(key, value) {
      this.$store.dispatch('setCompanyAttributeAction', { [key]: value })
    },
    isNumber(evt, isMinusAllowed) {
      const isStarting0Allowed = !this.$route.path.includes('/create-fund')
      const input = evt.target.value
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const keyPressed = evt.key

      if (keyPressed === '-' && input.length === 0 && isMinusAllowed) {
        return
      }

      if (input.length === 0 && keyPressed === '0' && isStarting0Allowed) {
        evt.preventDefault()
        return
      }

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    numberWithDots(number) {
      if (!this.fieldIsEmpty(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    fieldIsEmpty: function(field) {
      return field === '' || field === null || field === undefined
    },
    handleBlur() {
      this.$emit('multiplied-attribute', { key: this.keyInStore, value: this.modifier })
    }
  },
  components: { FontAwesomeIcon },
  mounted() {
    this.addCompanyAttribute(this.keyInStore, this.amount)
    this.modifier = this.amount
    if (this.alreadySelected) {
      this.modifier = this.alreadySelected
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  border-bottom: 1px solid #b2bec3;
  padding: 16px 0px;
}
.header {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 0;
}

.multiplied {
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
}

.increase {
  color: green;
}
.decrease {
  color: red;
}

@media screen and (min-width: 1200px) {
  .multiplied {
    font-size: 16px;
  }
}
</style>
